module.exports = __webpack_public_path__ + "static/media/RestaurantLandingPage.b747f875.jpeg";